export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70b882522d906c6d957a4e82b43058a610890234b2&name=pushAdClickData!'